import styled from 'styled-components';

export const CustomListStyled = styled.div`
    /* .MuiAutocomplete-listbox .MuiAutocomplete-option {
        display: flex;
        justify-content: space-between;
    } */
    li {
        display: flex;
        flex-direction: row-reverse;
        text-align: left;
        span {
            flex: 1;
        }
    }
    .badge {
        flex: inherit;
        font-weight: 600;
        background-color: #f0f4f9;
        color: #303641;
        padding: 5px 10px;
        border-radius: 6px;
        margin-left: 5px;
        text-align: center;
        min-width: 3.5em;
    }
    .MuiPaper-root {
        width: 400px;
    }
    @media only screen and (max-width: 600px) {
        .MuiPaper-root {
            width: 100%;
        }
    }
`;
export const CustomListBox2Styled = styled.div`
    .last-search-area {
        padding: 16px;
        .cardArea {
            position: relative;

            .closeButton {
                position: absolute;
                top: 5px;
                right: 5px;
                bottom: 0;
                margin: auto;
                z-index: 2;
                svg {
                    width: 18px;
                    height: 18px;
                }
            }
        }
        .title {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 15px;
        }
        .card {
            cursor: pointer;
            padding: 10px;
            margin: auto;
            position: relative;
            margin-bottom: 10px;
            background-color: var(--mui-palette-background-background1);
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            gap: 5px;
            .cardContent {
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                padding: 0px 5px;
                .leftCard {
                    display: flex;
                    gap: 12px;
                    font-size: 12px;
                    font-weight: 400;
                    svg {
                        width: 18px;
                        height: 18px;
                    }
                }
            }
            .cardInfo {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                padding: 0px 5px;
                align-items: center;
                font-size: 10px;
                font-weight: 400;
                line-height: 140%;
                gap: 5px;
                color: var(--mui-palette-text-secondary);

                .line {
                    border-left: 2px solid var(--mui-palette-text-secondary);
                    height: 12px;
                    opacity: 0.3;
                }
                .event-icon {
                    width: 18px;
                    height: 18px;
                }
                & > div {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 5px;
                }
            }
        }
        .cities-buttons {
            div {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                flex-wrap: wrap;
                flex-direction: row;
                justify-content: space-around;
                gap: 12px;
                margin-bottom: 15px;
                button {
                    width: 100%;
                    text-transform: capitalize;
                    background-color: var(--mui-palette-background-background1);
                    border-color: transparent;
                    font-size: 14px;
                    color: var(--mui-palette-text-secondary);
                    &:hover {
                        border-color: var(--mui-palette-primary-main);
                    }
                }
            }
        }
    }
    .MuiPaper-root {
        width: 400px;
    }
    @media only screen and (max-width: 600px) {
        .MuiPaper-root {
            width: 100%;
        }
    }
`;

export const PassengerCardStyled = styled.div`
    .passengerCard {
        width: 283px;
        padding: 10px 20px;
        .passengerCardContent {
            display: flex;
            flex-direction: row;
            align-items: center;
            .label {
                flex: 1;
                font-size: 14px;
                font-weight: 500;
                color: var(--mui-palette-text-primary);
                span {
                    font-size: 10px;
                    color: var(--mui-palette-text-secondary);
                }
            }
            .buttons {
                display: flex;
                flex-direction: row;
                color: var(--mui-palette-text-disabled);
                align-items: center;
                .count {
                    width: 30px;
                    text-align: center;

                    color: var(--mui-palette-text-primary);
                }
            }
        }
        .age-area {
            margin-top: 20px;
            .child-age-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 20px;
                margin-bottom: 10px;

                .age-select {
                    width: 110px;
                }
            }
        }

        .button-group {
            border-radius: 21px !important;
            background: #f0f4f9;
            margin-top: 15px;
            margin-bottom: 10px;
            .MuiButtonBase-root {
                padding: 8px 25px;
                border-color: transparent;
                border-radius: 21px !important;
                text-transform: inherit;
                &.Mui-selected {
                    background-color: var(--mui-palette-primary-main);
                    color: white;
                }
            }
        }
    }
`;
export const SearchBarWidgetDrawerStyled = styled.div`
    padding: 15px;
    padding-bottom: 30px;
    position: relative;
    .form-area {
        background-color: var(--mui-palette-primary-main);

        padding: 8px;
        border-radius: 12px;
    }
    .title {
        font-size: 16px;
        font-weight: 600;
        color: #303641;
        min-height: 24px;
        display: flex;
        align-items: center;
        margin-bottom: 15px;
    }
    .close {
        color: #c1c3c8;
        font-size: 24px;
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px;
        margin-top: 5px;
    }
`;
export const WidgetDrawerStyled = styled.div`
    padding: 15px;
    /* padding-bottom: 50px; */
    position: relative;
    .title {
        font-size: 14px;
        font-weight: 600;
        color: #303641;
        min-height: 24px;
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        position: sticky;
        top: 0px;
        background-color: white;
        padding: 15px;
        z-index: 1;
        margin: -15px;
        margin-bottom: 0px;
        display: flex;
        justify-content: space-between;
        margin-left: 5px;
        &.station {
            display: flex;
            justify-content: flex-start;
            margin-left: -25px;
        }
    }
    .close {
        color: #c1c3c8;
        font-size: 24px;
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px;
        margin-top: 5px;
    }
    .button {
        padding-right: 30px;
    }
    .deptoland > div > .box {
        background-color: white;
    }
    .deptoland {
        display: flex;
        flex-direction: column;
        background-color: #fff;
        margin: 0px;
        padding: 15px !important;
        border-radius: 8px;
        & > div > .box {
            padding: 0 !important;
        }
        & > div:not(.airport-warning-mobile) {
            order: 1;
            width: 100%;
            box-sizing: content-box;
            margin-bottom: 15px;
        }
        & > div.airport-warning-mobile {
            order: 2;
            &:not(:last-child) {
                display: none;
            }
        }
    }
`;

export const PageStyled = styled.div`
    flex: 1;

    .box {
        margin-top: 0;

        .head {
            display: flex;
            flex-direction: column;
            .top {
                display: flex;
                flex-direction: row;
                width: 100%;
                .from-to {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    font-size: 12px;
                    align-items: center;
                    font-weight: 400;
                    gap: 10px;
                    .icon {
                        font-size: 18px;
                        color: var(--mui-palette-primary-main);
                    }
                }
                .buttons {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    flex: 1;
                    .edit {
                        background-color: transparent;
                        border: #f0f4f9 solid 2px;
                        border-radius: 6px !important;
                        color: #303641;
                        padding: 4px 10px;
                        font-weight: 600;
                    }
                }
            }
            .bottom {
                margin-top: 15px;
                width: 100%;
                display: flex;
                align-items: center;
                flex-direction: row;
                font-size: 12px;
                color: #303641;

                > * {
                    white-space: nowrap;
                }

                .date {
                    white-space: normal;
                }
                .pasenger {
                    .material-icons {
                        line-height: 18px;
                        font-size: 14px;
                        margin-right: 3px;
                    }
                }
            }

            .trip-info {
                padding: 0px;
                /* .box {
                box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.08);
                border-radius: 6px;
                background-color: #fff;
                padding: 20px;
                color: #303641;
                display: flex;
                flex-direction: column;
                font-size: 14px;
                margin-top: 30px;
            } */
                .divider {
                    border-color: #c1c3c8;
                    opacity: 1;
                    margin: 0 10px;
                }
                .head {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: space-around;
                    flex: 1;
                    .left {
                        row-gap: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        align-items: center;
                        flex: 1 1 0%;
                        overflow: auto;
                        user-select: none;

                        .from-to {
                            display: flex;
                            flex-direction: row;
                            flex-wrap: nowrap;
                            align-items: end;

                            .icon {
                                font-size: 20px;
                                margin-right: 5px;
                                color: var(--mui-palette-primary-main);
                            }
                        }
                        .date {
                            white-space: nowrap;
                        }
                        .pasenger {
                            white-space: nowrap;
                        }
                        .type {
                            white-space: nowrap;
                        }
                    }
                    .right {
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        align-items: center;
                        overflow: auto;
                        user-select: none;
                        margin-left: 15px;
                        .daily-guess-button {
                            color: black;
                            background-color: var(--mui-palette-background-background1);
                            text-transform: capitalize;
                            border-radius: 6px;
                            box-shadow: none;
                            font-weight: 600;
                        }
                    }
                    .custom-tab {
                        min-height: inherit;
                        .MuiButtonBase-root {
                            padding: 0;
                            border-color: transparent;
                            min-height: 24px;
                            text-transform: inherit;
                            .icon {
                                font-size: 18px;
                            }
                            &::after {
                                content: '';
                                width: 0;
                                height: 0;
                                border-style: solid;
                                border-width: 5px;
                                border-color: #303641 transparent transparent transparent;
                                margin-left: 10px;
                                position: relative;
                                top: 2.5px;
                                transition: all 0.3s;
                            }
                            &.Mui-selected::after {
                                border-color: transparent transparent var(--mui-palette-primary-main) transparent;
                                top: -2.5px;
                            }
                        }
                        .MuiTabs-indicator {
                            display: none;
                        }
                    }
                }
            }
        }
        .divider {
            border-color: #c1c3c8;
            opacity: 1;
            margin: 0 7px;
        }
    }
    .custom-input-passenger {
        /* max-width: 190px; */
    }
    .form-area {
        width: 100%;
        /* padding-left: 10px; */
        padding: 4px;
        border-radius: 8px;
        background-color: var(--mui-palette-primary-main);

        .error-date {
            color: var(--mui-palette-error-main);
            font-weight: 400;
            font-size: 12px;
            padding-left: 15px;
            padding-top: 3px;
            margin: 0px;
        }
        .search-button {
            background-color: var(--mui-palette-secondary-light);
        }
    }
    .bg-color {
        background-color: transparent;
    }

    .change-button {
        color: #fff;
        background-color: #36739e !important;

        position: absolute;
        right: -20px;
        top: 5px;
        bottom: 0;
        margin: auto;
        height: 32px;
        width: 32px;
        z-index: 1;
    }
    .right-padding {
        .MuiInputLabel-root,
        .MuiInputAdornment-positionEnd {
            padding-right: 10px;
        }
    }
    .left-padding {
        .MuiInputLabel-root,
        .MuiInputBase-input {
            padding-left: 10px !important;
        }
    }
    .land-icon {
        position: relative;
        color: var(--mui-palette-primary-main);
        left: -3px;
        svg {
            font-size: 18px;
        }
    }

    .checkbox-white {
        left: 2px;
        position: relative;
    }
    .checkbox-white,
    .checkbox-white .MuiButtonBase-root {
        color: #fff;
        user-select: none;
    }
    .button-group {
        margin-bottom: 10px;
        .MuiButtonBase-root {
            background-color: rgb(255 255 255 / 20%);
            color: #fff;
            padding: 12px 25px;
            &.active {
                background-color: var(--mui-palette-secondary-main);
            }
        }
    }

    .link-group {
        margin: 14px 0;
        color: #fff;
        display: flex;
        gap: 10px;
        hr {
            border-color: #fff;
            opacity: 0.6;
            border-width: 1px;
        }
        a {
            display: flex;
            gap: 10px;
        }
    }

    .custom-autocomplete-list-box {
        .badge {
            background-color: #f0f4f9;
            color: #303641;
            padding: 5px 10px;
            border-radius: 6px;
        }
    }
    .passengerBox {
        position: relative;
    }
    .detail-close {
        margin-top: 5px;
        .relative-isOneWay {
            position: relative;

            .checkbox-isOneWay {
                position: absolute;
                top: -25px;
                right: 0;
                margin: 0;
            }
        }
    }

    .relative-isOneWay {
        position: relative;
    }
    .ghostDatePicker-control + .ghostDatePicker {
        background-color: transparent;
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        z-index: 2;
    }

    @media only screen and (max-width: 900px) {
        .custom-grid {
            gap: 0px;
            flex-direction: column;
            & > *:first-child {
                width: calc(100% + 10px);
            }
            & > * {
                width: 100%;
                flex: 1;
            }
        }
    }
    @media only screen and (max-width: 900px) {
        .form-area {
            width: 100%;
            /* padding-left: 10px; */
            padding: 4px;
            border-radius: 8px;
            background-color: var(--mui-palette-primary-main);
            .error-date {
                color: var(--mui-palette-error-main);
                font-weight: 400;
                font-size: 12px;
                padding-left: 15px;
                padding-top: 3px;
                margin: 0px;
            }
            .search-button {
                background-color: var(--mui-palette-secondary-light);
            }
        }
        .bg-color {
            background-color: transparent;
        }
        .custom-grid {
            flex-direction: column;
            & > *:first-child {
                width: calc(100% + 10px);
            }
            /* & > * {
                width: 100%;
                flex: 1;
            } */
            .change-button {
                color: rgb(255, 255, 255);
                transform: rotate(90deg);
                position: absolute;
                right: 7px;
                top: 65px;
                margin: auto;
                height: 32px;
                width: 32px;
                z-index: 1;
                background-color: rgb(54, 115, 158) !important;
            }
            .right-padding {
                .MuiInputLabel-root,
                .MuiInputAdornment-positionEnd {
                    padding-right: 0px;
                }
            }
            .left-padding {
                .MuiInputLabel-root,
                .MuiInputBase-input {
                    padding-left: 0px !important;
                }
            }
        }
    }
`;
